export const ROL_SUPERADMIN = 1;
export const ROL_ADMIN = 2;
export const ROL_USER = 3;
export const SERVICE_URL = 'http://localhost:6300';
// export const SERVICE_URL = 'https://ayumar.checkform.es/rest';
export const ALLOW_USER_ROLES = [ROL_SUPERADMIN, ROL_ADMIN];
